import { FC } from 'react';
import SortBy from 'components/shared/SortBy';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { RoundTripMode, getSortOptions } from 'constants/flight';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import Skeleton from 'react-loading-skeleton';
import RoundTrip from './RoundTrip';
import { FlightTopBarState } from 'ts/flight/classes/FlightTopBarStates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCandy } from '@fortawesome/sharp-duotone-solid-svg-icons';
import { isMultiFlight } from 'constants/generic';

interface FlightResultTopProps {
  onSortChange: (sort: string) => void;
  onChangeTripMode: (mode: RoundTripMode) => void;
  topBarState: FlightTopBarState;
  sortValue: string;
  onClickContinue: () => void;
}

const FlightResultTop: FC<FlightResultTopProps> = ({ onSortChange, topBarState, ...props }) => {
  const [t] = useTranslation();
  const [urlParams] = useSearchParams();
  const isRoundTrip = urlParams.get('searchType') === '1';

  return (
    <div className="results-sort-by">
      {!!topBarState.totalFlightsCount ? (
        <div
          className="show-laptop-sm"
          style={{ width: isRoundTrip && isMultiFlight ? '66.67%' : '100%' }}
        >
          <Button
            title={t('filter.s')}
            className="btn btn-default"
            onClick={() => {
              const element = document.querySelector('.flight-filter-wr') as HTMLElement;
              element.classList.toggle('visible-responsive');
            }}
          />
          <Button
            title={t('sort.er')}
            className="btn btn-default"
            onClick={() => {
              const element = document.querySelector('.sort-responsive') as HTMLElement;
              element.classList.toggle('visible-responsive');
            }}
          />
        </div>
      ) : (
        <div
          className="show-laptop-sm"
          style={{ width: isRoundTrip ? 'calc(64.67vw - 15px)' : 'calc (100vw - 15px)' }}
        >
          <Skeleton width={`calc(${isRoundTrip ? '33.33' : '50'}vw - 15px)`} height={38} />
          <Skeleton width={`calc(${isRoundTrip ? '33.33' : '50'}vw - 15px)`} height={38} />
        </div>
      )}
      <SortBy
        onSortChange={onSortChange}
        newSort={props.sortValue}
        options={getSortOptions(
          urlParams.get('departureCode') || '',
          urlParams.get('arrivalCode') || ''
        )}
      />

      {urlParams.get('searchType') === '1' && isMultiFlight && (
        <RoundTrip onChangeMode={props.onChangeTripMode} onClickContinue={props.onClickContinue} />
      )}

      <div className="sort-by-item-total ph-10">
        <span style={{ marginInlineStart: 'auto' }}>
          {!topBarState.pollingFinished && (
            <span className="ph-10">
              <FontAwesomeIcon icon={faCandy as any} spin className="text-contrast" size="lg" />
            </span>
          )}
          <span>{topBarState.visibleFlightsCount}</span>
          <span className="ph-5">{t('flight.found_from')}</span>
          <span>{topBarState.totalFlightsCount}</span>
        </span>
      </div>
    </div>
  );
};

export default withErrorBoundary(FlightResultTop, 'FlightResultTop');
